<template>
  <div class="container">
    <div class="row justify-content-center">
      <div class="col-md-8">
        <div class="card">
          <div class="card-header">Moje konto - HASŁO</div>
          <div class="card-body text-center">
            <a :href="webLink" target="_blank">
              <img class="p-3" :src="logoSrc" alt="skp"
            /></a>
            <form
              v-if="validated"
              action="#"
              method="POST"
              @submit.prevent="setPassword"
            >
              <div class="form-group row">
                <label
                  for="userable_id"
                  class="col-md-4 col-form-label text-md-right"
                  >Numer licencji</label
                >
                <div class="col-md-6">
                  <input
                    id="userable_id"
                    type="number"
                    class="form-control"
                    name="userable_id"
                    required
                    autocomplete="userable_id"
                    autofocus
                    v-model="form.userable_id"
                  />
                </div>
              </div>
              <input
                type="hidden"
                name="token"
                class="form-control"
                :value="form.token"
              />
              <div class="form-group row">
                <label for="email" class="col-md-4 col-form-label text-md-right"
                  >E-mail</label
                >
                <div class="col-md-6">
                  <input
                    id="email"
                    type="email"
                    class="form-control"
                    name="email"
                    required
                    autofocus
                    autocomplete="email"
                    v-model="form.email"
                  />
                </div>
              </div>
              <div class="form-group row">
                <label
                  for="password"
                  class="col-md-4 col-form-label text-md-right"
                  >Wprowadź hasło</label
                >
                <div class="col-md-6">
                  <input
                    id="password"
                    type="password"
                    class="form-control"
                    name="password"
                    required
                    v-model="form.password"
                  />
                </div>
              </div>
              <div class="form-group row">
                <label
                  for="password_confirmation"
                  class="col-md-4 col-form-label text-md-right"
                  >Powtórz hasło</label
                >
                <div class="col-md-6">
                  <input
                    id="password_confirmation"
                    type="password"
                    class="form-control"
                    name="password_confirmation"
                    required
                    autocomplete="password_confirmation"
                    v-model="form.password_confirmation"
                  />
                </div>
              </div>
              <div class="form-group row mb-10 justify-content-md-center">
                <div class="col-md-10">
                  <p class="font-italic small mb-2" v-html="allowedText"></p>
                </div>
              </div>
              <p v-if="errors.length" class="error offset-md-2"></p>
              <ul>
                <li
                  v-for="error in errors"
                  v-bind:key="error"
                  class="text-danger justify-content-md-start"
                  v-html="error"
                ></li>
              </ul>
              <div class="form-group row mb-10 justify-content-md-center">
                <div class="col-md-5">
                  <button type="submit" class="btn btn-success btn-block my-2">
                    Zapisz hasło
                  </button>
                </div>
              </div>
            </form>
            <div v-else-if="validated === 'error'" class="form-group row mb-10">
              <div class="col-md-8 offset-md-1">
                Link wygasł. Ponów prośbę o nowe hasło.
                <router-link
                  :to="{
                    name: 'Login',
                    props: { program: program },
                  }"
                  >Powrót do strony głównej</router-link
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import { mapGetters } from 'vuex';
import { isTestAccountRegistered } from '../../shared/isTestAccountRegistered';

export default {
  name: 'SetPassword',
  props: {
    logoSrc: {},
  },
  data() {
    return {
      validated: false,
      errors: [],
      form: {
        token: '',
        email: '',
        password: '',
        password_confirmation: '',
        userable_id: '',
        userable_type: '',
      },
    };
  },
  computed: {
    ...mapGetters({
      program: 'getProgram',
    }),
    webLink() {
      return this.program === 'skp'
        ? 'https://www.ksiega-podatkowa.pl/'
        : 'https://www.samozatrudnienie.pl/';
    },
    userable_type() {
      if (this.program === 'skp') {
        return isTestAccountRegistered(this.form.userable_id)
          ? 'App\\Models\\SkpClientTest'
          : 'App\\Models\\SkpClient';
      }

      return isTestAccountRegistered(this.form.userable_id)
        ? 'App\\Models\\SamClientTest'
        : 'App\\Models\\SamClient';
    },
    allowedText() {
      return 'Hasło musi zawierać co najmniej 8 znaków, w tym małą i wielką literę, cyfrę i znak specjalny (@$!%*?&#^~`[]{};:\'"|,.<>/=+-_).';
    },
  },
  beforeCreate: function () {
    document.body.className = 'login';
  },
  mounted() {
    this.form.token = this.$route.params.hash;
    this.id = this.$route.query.email;
    this.validateToken();
  },
  methods: {
    validateToken() {
      this.form.userable_type = this.userable_type;
      axios
        .post('/api/validate', {
          token: this.form.token,
          id: this.id,
        })
        .then((response) => {
          this.validated = true;
        })
        .catch((error) => {
          this.validated = 'error';
        });
    },
    setPassword() {
      this.errors = [];
      this.validatePassword();
      this.form.userable_type = this.userable_type;
      if (this.errors.length === 0 && this.validated) {
        axios
          .post('/password/reset', this.form)
          .then((response) => {
            this.$router.push({ name: 'Login' });
          })
          .catch((error) => {
            let that = this;

            $.each(error.response.data.errors, function (key, value) {
              if (key === 'email') {
                that.errors.push(
                  'Konto zarejestrowałeś na inny e-mail. Wpisz e-mail i numer licencji podany podczas rejestracji i utwórz hasło'
                );
              }
              if (key === 'password') {
                this.errors.push('Podane hasła muszą być identyczne.');
              }
            });
          });
      }
    },
    validatePassword() {
      if (this.form.password_confirmation !== this.form.password) {
        this.errors.push('Podane hasła muszą być identyczne.');
      }
      if (
        !/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&#^~`[\]{};:'"|,.<>/=+-_])[A-Za-z\d@$!%*?&#^~`[\]{};:'"|,.<>/=+-_]{8,}$/.test(
          this.form.password
        )
      ) {
        this.errors.push(
          'Hasło musi zawierać co najmniej 8 znaków, w tym małą i wielką literę, cyfrę i znak specjalny (@$!%*?&#^~`[]{};:\'"|,.<>/=+-_). <br>Popraw hasło i kliknij Zapisz hasło.'
        );
      }
    },
  },
};
</script>

<style scoped>
ul {
  list-style-type: none;
}

input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

input[type='number'] {
  -moz-appearance: textfield;
}
</style>
